export default __webpack_public_path__ + "static/media/add-fee-disabled.b044bec2.svg";